<template>
  <!--快捷查询-->
  <find-quick></find-quick>
  <!--更多查询，放在抽屉里面-->
  <find-all></find-all>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { regFindState } from './state/state-find'
  import { findProps } from '../map'
  import type {
    IFindState
  } from '../map'

  // 组件
  import findQuick from './item/find-quick.vue'
  import findAll from './item/find-all-div.vue'

  export default defineComponent({
    name: 'nf-el-find-div',
    components: {
      findQuick,
      findAll
    },
    props: {
      ...findProps
    },
    setup(props) { // context
      // console.log('查询的props：', props)
      // 根据传入的属性，创建 状态
      const state: IFindState = regFindState(props) // as IFindState

      return {
        state
      }
    }
  })
</script>